import NavBar from "./NavBar";
import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";

const Dashboard = () => {
  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden font-sans">
      
      <SideBar />

      <div className="flex-1 flex flex-col min-w-0">
        
        <NavBar />

        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>

      </div>

    </div>
  );
};

export default Dashboard;